import React from 'react';
import { useTranslation } from 'react-i18next';
import { Customer } from '../../../types';
import './CustomerInfo.css';

interface CustomerInfoProps {
  customer: Customer | null | undefined;
  customerName?: string;
  title?: string;
  showDetails?: boolean;
  onSelectCustomer?: () => void;
  showSelectButton?: boolean;
}

export const CustomerInfo: React.FC<CustomerInfoProps> = ({
  customer,
  customerName,
  title,
  showDetails = true,
  onSelectCustomer,
  showSelectButton = false
}) => {
  const { t } = useTranslation();

  const displayName = customer?.name || customerName || '';

  return (
    <section className="sidebar-section customer-info">
      <div className="sidebar-header">
        <h3>{title || t('sidebar.customerInfo')}</h3>
        {showSelectButton && onSelectCustomer && (
          <button onClick={onSelectCustomer} className="btn-select btn-select-small">
            {t('sidebar.selectCustomer')}
          </button>
        )}
      </div>
      <div className="sidebar-grid">
        <div className="sidebar-field">
          <label>{t('sidebar.customerName')}</label>
          <input type="text" value={displayName} readOnly className="input-readonly" />
        </div>
        {showDetails && customer && (
          <>
            <div className="sidebar-field">
              <label>{t('sidebar.address')}</label>
              <input type="text" value={customer.address || '-'} readOnly className="input-readonly" />
            </div>
            <div className="sidebar-field">
              <label>{t('sidebar.city')}</label>
              <input type="text" value={customer.city || '-'} readOnly className="input-readonly" />
            </div>
            <div className="sidebar-field">
              <label>{t('sidebar.country')}</label>
              <input type="text" value={customer.countryCode || '-'} readOnly className="input-readonly" />
            </div>
            <div className="sidebar-field">
              <label>{t('sidebar.email')}</label>
              <input type="text" value={customer.email || '-'} readOnly className="input-readonly" />
            </div>
            <div className="sidebar-field">
              <label>{t('sidebar.telephone')}</label>
              <input type="text" value={customer.phone || '-'} readOnly className="input-readonly" />
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default CustomerInfo;
